var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._g(_vm._b({staticClass:"card",style:(_vm.style),attrs:{"elevation":"0","ripple":false,"tile":""}},'v-card',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(s,name){return _vm._t(name)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }